// import { QRCodeCanvas } from "qrcode.react";

// const QuizQRCode = () => {
//   const quizId = "quiz_8f92k";
//   const quizUrl = `${window.location.origin}/quiz/${quizId}`;

//   return (
//     <div className="flex items-center justify-center py-12 px-4">
//       <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm text-center">
        
//         {/* Header */}
//         <h2 className="text-2xl font-bold text-gray-800 mb-2">
//           Scan to Attempt Quiz
//         </h2>
//         <p className="text-gray-600 mb-6">
//           Open your phone camera and scan the QR code
//         </p>

//         {/* QR Container */}
//         <div className="flex items-center justify-center mb-4">
//           <div className="p-4 rounded-xl bg-gradient-to-br from-indigo-50 to-indigo-100">
//             <QRCodeCanvas
//               value={quizUrl}
//               size={180}
//               bgColor="#ffffff"
//               fgColor="#1f2937" // gray-800
//               level="H"
//             />
//           </div>
//         </div>

//         {/* Quiz URL */}
//         <p className="text-xs text-gray-500 break-all mb-4">
//           {quizUrl}
//         </p>

//         {/* Fallback Button */}
//         <a
//           href={quizUrl}
//           className="inline-block w-full bg-gradient-to-r from-indigo-600 to-indigo-400 text-white font-semibold py-2 px-4 rounded-md hover:from-indigo-700 hover:to-indigo-500 transition-all"
//         >
//           Open Quiz in Browser
//         </a>

//         {/* Footer Note */}
//         <p className="text-xs text-gray-400 mt-4">
//           No app required • Mobile friendly
//         </p>
//       </div>
//     </div>
//   );
// };

// export default QuizQRCode;






import { QRCodeCanvas } from "qrcode.react";

const QuizQRCode = () => {
  const quizUrl = "https://quzy.in/quiz";

  return (
    <div className="flex items-center justify-center py-12 px-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm text-center">
        
        {/* Header */}
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Scan to Attempt Quiz
        </h2>
        <p className="text-gray-600 mb-6">
          Open your phone camera and scan the QR code
        </p>

        {/* QR Container */}
        <div className="flex items-center justify-center mb-4">
          <div className="p-4 rounded-xl bg-gradient-to-br from-indigo-50 to-indigo-100">
            <QRCodeCanvas
              value={quizUrl}
              size={180}
              bgColor="#ffffff"
              fgColor="#1f2937" // gray-800
              level="H"
            />
          </div>
        </div>

        {/* Quiz URL */}
        <p className="text-xs text-gray-500 break-all mb-4">
          {quizUrl}
        </p>

        {/* Fallback Button */}
        <a
          href={quizUrl}
          className="inline-block w-full bg-gradient-to-r from-indigo-600 to-indigo-400 text-white font-semibold py-2 px-4 rounded-md hover:from-indigo-700 hover:to-indigo-500 transition-all"
        >
          Open Quiz in Browser
        </a>

        {/* Footer Note */}
        <p className="text-xs text-gray-400 mt-4">
          No app required • Mobile friendly
        </p>
      </div>
    </div>
  );
};

export default QuizQRCode;
 